import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import Slider from 'react-slick';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class Careers extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		this.state = {
			buttonSelected: 'humility',
			learnMore: false,
		};
	}

	componentWillMount() {
		document.title = 'Diamonds Direct Careers - Engagement Rings, Jewelry, and More';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	}

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  userNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  selectButton(val) {
  	this.setState({ buttonSelected: val });
  }

  toggleLearnMore() {
  	this.setState({ learnMore: !this.state.learnMore });
  }

  nextSlide() {
    this.sliderObject.slickNext();
  }

  prevSlide() {
    this.sliderObject.slickPrev();
  }

  renderRotatingBanner() {
  	const settings = {
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 10000,
      cssEase: "linear",
      arrows: false,
    };
  	return <div className='familyRotatingBanner'>
  		<div className="bannerLeft" onClick={::this.prevSlide}>
        <div className="leftArrow"></div>
      </div>
      <div className="bannerRight" onClick={::this.nextSlide}>
        <div className="rightArrow"></div>
      </div>
	  	<Slider ref={(slider) => { this.sliderObject = slider; }} {...settings}>
	  		<div className={'rotatingBannerItem'}>
					<img src='https://ddw2.diamondsdirect.com/img/careers/family1.jpg' />
	  		</div>
	  		<div className="rotatingBannerItem">
	  			<img src='https://ddw2.diamondsdirect.com/img/careers/family2.jpg' />
	  		</div>
	  		<div className="rotatingBannerItem">
	  			<img src='https://ddw2.diamondsdirect.com/img/careers/family3.jpg' />
	  		</div>
	  		<div className="rotatingBannerItem">
	  			<img src='https://ddw2.diamondsdirect.com/img/careers/family4.jpg' />
	  		</div>
	  	</Slider>
  	</div>;
  }

	render() {
		return <div className='Careers'>
			<div className='whoWeAreBlock'>
				<div className='whoWeAreBackground'></div>
				<div className='imageTile'>
					<div className='imageLabel'>Who We Are</div>
				</div>
				<div className='copyTile'>
					<div className='mainCopy'><span className='textEm'>We are</span> a rare company in that we exist for our customers. Extraordinary service is the result of anticipating each customer’s unique needs and providing the solution before the customer is even aware of it. Our road to success starts with great people who share a common vision: to create life-long relationships with everyone who walks through our doors. We create this exceptional customer experience by starting with a one-of-a-kind employment experience. We are a family made up of individuals with a like-minded approach to hard work and a diversified way of charging at barriers that stand in our way. When we add in that we are SERIOUS about having FUN, we feel that there is no better place to work! We hope that you will explore an opportunity with us and discover how rewarding it is to be a Rhino on our team!</div>
					<div className='copyWrapper'>
						<div className='copyButton' onClick={() => this.newTabNav('https://signetjewelers.wd1.myworkdayjobs.com/en-US/Diamonds_Direct')}>We are Hiring!</div>
					</div>
				</div>
			</div>
			<div className='cultureBlock'>
				<div className='cultureHeader'>
					<img src='https://ddw2.diamondsdirect.com/img/careers/culture.jpg' />
					<div className='cultureLabel'>Rhino Culture</div>
				</div>
				<div className='cultureButtons'>
					<div className='copyWrapper'>
						<div className='copyTitle'>We call ourselves <span className='titleEm'>RHINOS</span>...</div>
						<div className='copyBody'>Being a rhino is being entrepreneurial at heart. It means owning your job and what you accomplish no matter which role you hold within the company. Rhinos have this innate, internal personal drive. Below are some characteristics that we feel capture our rhino spirit.</div>
					</div>
					<div className='buttonWrapper'>
						<div 
							className={this.state.buttonSelected == 'humility' ? 'humilityButton cultureButton selected' : 'humilityButton cultureButton'}
							onClick={() => this.selectButton('humility')}>
						</div>
						<div 
							className={this.state.buttonSelected == 'ethic' ? 'ethicButton cultureButton selected' : 'ethicButton cultureButton'}
							onClick={() => this.selectButton('ethic')}>
						</div>
						<div 
							className={this.state.buttonSelected == 'passion' ? 'passionButton cultureButton selected' : 'passionButton cultureButton'}
							onClick={() => this.selectButton('passion')}>
						</div>
						<div 
							className={this.state.buttonSelected == 'ownership' ? 'ownershipButton cultureButton selected' : 'ownershipButton cultureButton'}
							onClick={() => this.selectButton('ownership')}>
						</div>
					</div>
				</div>
				<div className='buttonResults'>
					<div className={this.state.buttonSelected == 'humility' ? 'humilityResult buttonResult selected' : 'humilityResult buttonResult'}>
						<ul>
							<li>No one is more important than anyone else. It takes everyone to make this business work.</li>
							<li>Admit your mistakes. Failing is how you learn, but you have to admit that you failed to learn the lesson.</li>
						</ul>
					</div>
					<div className={this.state.buttonSelected == 'ethic' ? 'ethicResult buttonResult selected' : 'ethicResult buttonResult'}>
						<ul>
							<li>Be excited and happy to come to work every day.</li>
							<li>Do whatever it takes to get the job done.</li>
							<li>"That’s not my job" just does NOT exist here.</li>
						</ul>
					</div>
					<div className={this.state.buttonSelected == 'passion' ? 'passionResult buttonResult selected' : 'passionResult buttonResult'}>
						<ul>
							<li>Love what you do. It feels a lot less like work when you have a passion for what you do.</li>
						</ul>
					</div>
					<div className={this.state.buttonSelected == 'ownership' ? 'ownershipResult buttonResult selected' : 'ownershipResult buttonResult'}>
						<ul>
							<li>We all have the same goal and can only exceed our goals by working together.</li>
							<li>Do not let anything stand in your way. Work hard and be creative. Rhinos are unstoppable once they start charging.</li>
						</ul>
					</div>
				</div>
			</div>
			<div className='differenceBlock'>
				<img className='diffDesktop' src='https://ddw2.diamondsdirect.com/img/careers/dddif.svg' />
				<img className='diffMobile' src='https://ddw2.diamondsdirect.com/img/careers/dddif_mobile.jpg' />
			</div>
			<div className='familyBlock'>
				<div className='familyTitle'>WE ARE A <span className='titleEm'>RHINO</span> FAMILY</div>
				<div className='rotatingBannerWrapper'>
					{this.renderRotatingBanner()}
				</div>
				<div className='familySubtitle'>Get a glimpse into our Rhino Culture! Check us out on:</div>
				<div className='familySocialWrapper'>
					<div className='socialIcon' onClick={() => this.newTabNav('https://twitter.com/ddopportunities')}>
						<img src='https://ddw2.diamondsdirect.com/img/careers/twitter.svg' />
					</div>
					<span>&nbsp;&amp;&nbsp;</span>
					<div className='socialIcon' onClick={() => this.newTabNav('https://www.linkedin.com/company/diamonds-direct/')}>
						<img src='https://ddw2.diamondsdirect.com/img/careers/in.svg' />
					</div>
				</div>
			</div>
			<div className='benefitsBlock'>
				<div className='benefitsTitle'>Our Benefits</div>
				<div className='benefitsText'>At Diamonds Direct, our true strength lies in our passionate, knowledgable and hard working people. We work together, as a team, to create the best shopping experience for our customers. We value each and every team member and offer competitive benefits to our Rhinos.</div>
				<div className={this.state.learnMore ? 'learnMoreBody open' : 'learnMoreBody'}>
					<ul>
						<li>Competitive Compensation</li>
						<li>Bonus Potential</li>
						<li>Medical</li>
						<li>Health Advocate</li>
						<li>Dental</li>
						<li>Vision</li>
						<li>Life Insurance</li>
					</ul>
					<ul>
						<li>Voluntary Life Insurance</li>
						<li>Long-Term Disability</li>
						<li>Short-Term Disability</li>
						<li>Flexible Spending Account (FSA)</li>
						<li className='indent'>Medical</li>
						<li className='indent'>Dependent Care</li>
						<li>Retirement 401K Plan (with a match)</li>
					</ul>
					<ul>
						<li>Up to 4 Weeks of Paid Time Off</li>
						<li>Paid Holidays</li>
						<li>Bereavement Leave</li>
						<li>Employee Assistance Program</li>
						<li>An attractive employee discount</li>
						<li>Perks at Work Program</li>
						<li>Travel Perks</li>
						<li>Relocation Assistance</li>
					</ul>
				</div>
				<div className='learnMoreToggle' onClick={::this.toggleLearnMore}>
					{this.state.learnMore === false ?
						<div>
							<div className='learnMoreText'>Learn More</div>
							<div className='learnMoreDownArrow'>
								<i className={'fas fa-chevron-down'}></i>
							</div>
						</div> :
						null
					}
					{this.state.learnMore === true ?
						<div className='learnMoreUpArrow'>
							<i className={'fas fa-chevron-up'}></i>
						</div> :
						null
					}

				</div>
			</div>
			<div className='buttonBlock'>
				<div className={'actionButton jobsButton'} onClick={() => this.newTabNav('https://signetjewelers.wd1.myworkdayjobs.com/en-US/Diamonds_Direct')}>CHECK OUT OUR JOB OPENINGS</div>
			</div>
			<div className='buttonSubtext'>
				If you have questions or need assistance with the job application, please email <a href='mailto:careers@diamondsdirect.com'>careers@diamondsdirect.com</a> or call <a href='tel:7045329041'>704-532-9041</a> and ask to speak with Courtney Love or Kimberly Berry.
			</div>
			<div className='eeoStatement'>
				Diamonds Direct empowers all of our team members from across the company to make contributions that enhance the employee and customer experience. We are passionate about diversity and inclusion as well as promoting an environment where recruitment, hiring and promotional decisions are made with fondness for our differences.
			</div>
		</div>;
	}
}
export default Careers;

function mapStateToProps(state) {
  return {
    header: state.header,
  };
}

export const CareersContainer = connect(
  mapStateToProps,
  allActionCreators
)(Careers);


// WEBPACK FOOTER //
// ./src/components/views/careers/Careers.jsx